import React, { Fragment, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';

import Table from 'components/customTable';

import ZpFilter from '../../../../components/zpFilter';
import { CAROUSEL_FILTERS,FILTER_PARAMS } from '../../../../components/zpFilter/filterUtils';
import CommonService from '../../../../services/commonService';
import { JOB_BUCKET_GROUP } from '../../../../utils/constant';
import HorizontalBarChart from '../../charts/horizontalBarChart';

const xAxisLabels = ['0%', '20%', '40%', '60%', '80%', '100%'];

const CompanySize = ({
  jobTitle,
  companySizes,
  companySizeContentBlurb,
  filterValueRange,
  filterLogEventCallback,
}) => {
  const yAxisLabels = companySizes.map(({ size }) => {
    return size === '> 10,000' ? size : `${size} employees`;
  });
  const values = companySizes.map(({ sizePercent }) => sizePercent);
  const tableData = companySizes.map((x) => ({
    ...x,
    sizeDisplay: x.size + ' employees',
    sizePercentDisplay: x.sizePercent + '%',
  }));

  const [compareValues, setCompareValues] = useState([]);
  const [compareJobTitle, setCompareJobTitle] = useState('');

  const handleFilterUpdate = async (_, data) => {
    const { value = jobTitle } = data;
    const jobTitleComparisonValue = value.originalSearch ? value.originalSearch : value;

    if (jobTitleComparisonValue === jobTitle && _isEmpty(compareValues)) {
      return;
    } else if (jobTitleComparisonValue === jobTitle && !_isEmpty(compareValues)) {
      setCompareValues([]);
      setCompareJobTitle('');
      return;
    }

    try {
      const jobTitles = [jobTitleComparisonValue];
      const data = { jobTitles };
      const newCompanySizes = await CommonService.fetchTitleCompanySizesData(data);
      const newValues = newCompanySizes[0].map(({ sizePercent }) => sizePercent);
      setCompareJobTitle(jobTitles[0]);
      setCompareValues(newValues);
    } catch (error) {
      console.log(error);
    }
  };

  const filterProps = () => {
    const filterGroup = `${JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_JOBS}-companySizes`;
    return {
      ...CAROUSEL_FILTERS[FILTER_PARAMS.JOB_TITLE],
      filterGroup,
      buttonText: 'Compare Jobs',
      valueRange: filterValueRange,
      onApply: handleFilterUpdate,
      onClear: handleFilterUpdate,
      options: {
        logEvent: () =>
          filterLogEventCallback(
            `${JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_JOBS}-companySizes`
          ),
      },
    };
  };

  return (
    <Fragment>
      <h3 className="cmpSectionh4 mb-3">{`Company Size`}</h3>
      {companySizeContentBlurb && companySizeContentBlurb.content && (
        <div
          className="mt-3 mb-4"
          dangerouslySetInnerHTML={{ __html: companySizeContentBlurb.content }}
        />
      )}
      <ZpFilter {...filterProps()} />
      <HorizontalBarChart
        tooltipKey={'companySizes'}
        yAxisLabels={yAxisLabels}
        xAxisLabels={xAxisLabels}
        values={values}
        compareValues={compareValues}
        yAxisLabelsWidth={'106px'}
        jobTitle={jobTitle}
        compareJobTitle={compareJobTitle}
      />
      <div className="mb-5 z-mt-48">
        <Table
          columnConfig={{
            sizeDisplay: {
              columnName: 'Company Size',
              customSortByField: 'size',
            },
            sizePercentDisplay: {
              columnName: 'Percentages',
              customSortByField: 'sizePercent',
              // defaultSortDirection: 'desc'
            },
          }}
          bodyData={tableData}
          defaultRowsDisplay={99}
          tableHeaderTitleContent={
            <h3 className="zp-title-h3 text-capitalize z-mb-24">{`${jobTitle} Jobs By Employer Size`}</h3>
          }
        />
      </div>
    </Fragment>
  );
};

export default CompanySize;
